/* global axios */
import ApiClient from '../ApiClient';

class CaptainCeoDashboard extends ApiClient {
  constructor() {
    super('captain/ceo_dashboard', { accountScoped: true });
  }

  get({ since, until: untilTs } = {}) {
    return axios.get(this.url, {
      params: { since, until: untilTs },
    });
  }
}

export default new CaptainCeoDashboard();
